

export default {
  data() {
    return {
      // 房型資料
      rooms: [],
      isRoomGuestDropdownVisible: false, // 控制房間乘客選單的顯示
      roomCount: 0, // 房間數量
      roomAdultCount: 0, // 成人數量
      roomChildCount: 0, // 小孩數量
      roomInfantCount: 0, // 嬰兒數量
      packages: [], // 動態活動專案資料
      
    };

    
  },
  computed: {
    totalRoomGuests() {
      // 總房間人數計算
      return this.roomAdultCount + this.roomChildCount + this.roomInfantCount;
    },
  },
  methods: {
    toggleRoomGuestDropdown() {
      this.isRoomGuestDropdownVisible = !this.isRoomGuestDropdownVisible;
    },
    closeRoomGuestDropdown() {
      this.isRoomGuestDropdownVisible = false;
    },
    incrementRoomCount() {
      this.roomCount++;
    },
    decrementRoomCount() {
      if (this.roomCount > 1) this.roomCount--;
    },
    incrementRoomAdult() {
      this.roomAdultCount++;
    },
    decrementRoomAdult() {
      if (this.roomAdultCount > 0) this.roomAdultCount--;
    },
    incrementRoomChild() {
      this.roomChildCount++;
    },
    decrementRoomChild() {
      if (this.roomChildCount > 0) this.roomChildCount--;
    },
    incrementRoomInfant() {
      this.roomInfantCount++;
    },
    decrementRoomInfant() {
      if (this.roomInfantCount > 0) this.roomInfantCount--;
    },
    

    navigateToCart() {
      this.$router.push("/order").catch(err => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err); // 僅記錄非重複導航的錯誤
        }
      });
    },
    
    
  },
  created() {
    this.fetchPackages(); // 組件創建時加載活動資料
  },
};
